import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

import { ISelectChoices } from '../../../interfaces/generic-select-config.interface';
import { EnumsState } from '../../../store/state/enums.state';

@Component({
    selector: 'app-school-settings',
    templateUrl: './school-settings.component.html',
    styleUrls: ['./school-settings.component.scss'],
})
export class SchoolSettingsComponent {
    @Select(EnumsState.storageEnumChoices) public storageEnumChoices$: Observable<ISelectChoices[]>;

    @Input() public control: FormGroup;
    @Output() public elementSizeModification = new EventEmitter<void>();

    public get calendar(): FormControl {
        return this.control.get('calendar') as FormControl;
    }

    // medias settings
    public get isMediasActive(): FormControl {
        return this.control.get('medias.is_active') as FormControl;
    }

    public get storageTypeId(): FormControl {
        return this.control.get('medias.storage_type_id') as FormControl;
    }

    // shop settings
    public get isShopActive(): FormControl {
        return this.control.get('shop.is_active') as FormControl;
    }

    public get meals(): FormControl {
        return this.control.get('shop.meals') as FormControl;
    }

    public get nursery(): FormControl {
        return this.control.get('shop.nursery') as FormControl;
    }

    public get homeworks(): FormControl {
        return this.control.get('shop.homeworks') as FormControl;
    }

    public get activities(): FormControl {
        return this.control.get('shop.activities') as FormControl;
    }

    public get electronicPayments(): FormControl {
        return this.control.get('shop.electronic_payments') as FormControl;
    }
}
